export enum WishlistEventTypeEnum {
  ADD = 'add_to_wishlist',
  REMOVE = 'remove_from_wishlist',
}
